import config from '@/config';

/**
 * Sets the document Favicon
 * @param {String} url
 */
export const setFavicon = url => {
    if (config.ENV === 'test') {
        return false;
    }

    let link = document.querySelector('link[rel~=icon]');

    if (link == undefined || link == null) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    link.href = url;
};

export const pxFromString = (valueString, parentElement = document.body) => {
    // Return 0 if the input isn't a valid string.
    if (typeof valueString !== 'string' || valueString.trim() === '') {
        return 0;
    }

    // Separate the numerical value from the unit.
    const value = parseFloat(valueString);
    const unit = String(valueString.match(/[\d.\-+]*\s*(.*)/)[1] || 'px').toLowerCase();

    // Return 0 if the numerical value is not a number.
    if (isNaN(value)) {
        return 0;
    }

    switch (unit) {
        case 'px':
            return value;

        case 'rem': {
            const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
            return value * rootFontSize;
        }

        case 'em': {
            const refElement = parentElement && parentElement instanceof HTMLElement ? parentElement : document.body;
            const parentFontSize = parseFloat(getComputedStyle(refElement).fontSize);
            return value * parentFontSize;
        }

        case '%': {
            // Note: '%' is context-dependent. This common implementation assumes it's
            // relative to the parent element's width, which is typical for layout properties.
            const refElement = parentElement && parentElement instanceof HTMLElement ? parentElement : document.body;
            return (value / 100) * refElement.clientWidth;
        }

        default:
            // For unitless values or unknown units, return the base number.
            return value;
    }
};

/**
 * Scroll the page to the first input error
 */
export const scrollToElement = (selector = '.v-input.error--text:first-of-type') => {
    const element = document.querySelector(selector);

    if (!element) {
        return false;
    }

    element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
};

export const copyToClipboard = textToCopy => {
    if (navigator.clipboard) {
        return navigator.clipboard.writeText(textToCopy);
    } else {
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;

        document.body.appendChild(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
        } catch (error) {
            console.error('Unable to copy value:', textToCopy, error);
        }

        document.body.removeChild(textArea);
    }
};
